define.alias("ember-power-select/components/power-select/trigger", "settings/components/power-select/trigger");